import { useContext, useState } from 'react';
import {
	GlobalContainerSettings,
	HeaderSettings,
	MainSettings,
	MenuItemBox,
	MenuItemLanguage,
	FooterSettings,
	BtnSettingsText,
	MenuItemLogout,
	LabelText,
	MenuDivider,
} from './styles';
import { BottomNavigations } from '../../components';
import { ThemeContext } from '../../contexts/themeContext';
import { AuthContext } from '../../contexts/auth';
import { useTranslation } from 'react-i18next';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import InfoIcon from '@mui/icons-material/Info';
import LanguageIcon from '@mui/icons-material/Language';
import Switch from '@mui/material/Switch';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';

function Settings() {
	const navigate = useNavigate();

	const { signOut } = useContext(AuthContext);

	const { toggleTheme, currentTheme } = useContext(ThemeContext);

	const { i18n } = useTranslation();

	const [seletedLanguage, setSelectedLanguage] = useState(
		i18n.language.split('-')[0]
	);

	const languages = {
		en: { nativeName: 'English' },
		de: { nativeName: 'Deutsch' },
		fr: { nativeName: 'French' },
	};

	const handleChangeLanguage = (event) => {
		setSelectedLanguage(event.target.value);
		i18n.changeLanguage(event.target.value);
	};

	return (
		<GlobalContainerSettings>
			<HeaderSettings>{`${i18n.t('settings')}`}</HeaderSettings>
			<MainSettings>
				<MenuItemBox>
					<DarkModeIcon />
					<BtnSettingsText sx={{ color: 'primary.main' }}>
						<LabelText
							sx={{ paddingLeft: '14px', color: 'primary.main' }}
						>{`${i18n.t('themeMode')}`}</LabelText>
					</BtnSettingsText>
					<Switch
						checked={currentTheme === 'dark'}
						onChange={toggleTheme}
						inputProps={{ 'aria-label': 'controlled' }}
					/>
				</MenuItemBox>
				<MenuDivider
					variant="middle"
					sx={{
						width: '70vw',
						margin: 'auto',
					}}
				/>

				<MenuItemBox>
					<InfoIcon />
					<BtnSettingsText sx={{ color: 'primary.main' }}>
						<Box onClick={() => navigate('/about')}>
							<LabelText
								sx={{ paddingLeft: '14px', color: 'primary.main' }}
							>{`${i18n.t('aboutUs')}`}</LabelText>
						</Box>
					</BtnSettingsText>
				</MenuItemBox>

				<MenuDivider
					variant="middle"
					sx={{
						width: '70vw',
						margin: 'auto',
					}}
				/>

				<MenuItemBox>
					<LanguageIcon />
					<BtnSettingsText sx={{ color: 'primary.main' }}>
						<LabelText
							sx={{ paddingLeft: '14px', color: 'primary.main' }}
						>{`${i18n.t('language')}`}</LabelText>
					</BtnSettingsText>
					<FormControl
						sx={{
							'.MuiOutlinedInput-notchedOutline': {
								borderWidth: '0px',
							},
						}}
					>
						<Select
							value={seletedLanguage}
							onChange={handleChangeLanguage}
							sx={{
								alignSelf: 'center',
								'.MuiOutlinedInput-notchedOutline': {
									borderColor: 'transparent',
								},
								'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
									borderColor: 'transparent',
								},
								'&:hover .MuiOutlinedInput-notchedOutline': {
									borderColor: 'transparent',
								},
							}}
							IconComponent={() => null}
						>
							{Object.entries(languages).map(([code, { nativeName }]) => (
								<MenuItemLanguage
									key={code}
									value={code}
									sx={{
										justifyContent: 'center',
										'&:hover': {
											backgroundColor: 'lightgray',
										},
									}}
								>
									{nativeName}
								</MenuItemLanguage>
							))}
						</Select>
					</FormControl>
				</MenuItemBox>
				<MenuItemLogout sx={{ backgroundColor: 'backGround.main' }}>
					<BtnSettingsText sx={{ color: 'primary.main' }} onClick={signOut}>
						<LabelText
							sx={{
								margin: 'auto',
								width: '60%',
								textAlign: 'center',
								color: 'primary.main',
							}}
						>{`${i18n.t('logout')}`}</LabelText>
					</BtnSettingsText>
				</MenuItemLogout>
			</MainSettings>

			<FooterSettings>
				<BottomNavigations current="settings" />
			</FooterSettings>
		</GlobalContainerSettings>
	);
}

export default Settings;
